import axios from 'axios';

const RoleService = {
  get(id) {
    return axios.get(`role/${id}`).catch((error) => {
      throw new Error(`RoleService.get ${error}`);
    });
  },
};

export default RoleService;
